'use client';

import { memo } from 'react';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { HButton } from '@/stories/atoms/buttons/mainButton/Button';

import core from './localization/core';
import { blobUrl } from '../../constants/variables';

const ChallengesSection = () => {
  const router = useRouter();

  return (
    <section
      className="flex flex-col gap-4 justify-center items-center mt-7 md:bg-[radial-gradient(71.39%_51.03%_at_50%_50%,rgba(138,43,226,0.7)_0%,rgba(138,43,226,0)_98%)] w-screen md:w-full relative"
      style={{
        backgroundImage: `url('${blobUrl}/ui/home/Bgdesafios.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="fade-top" />
      <Image
        src="/img/v2/home/dart.webp"
        alt="Challenge"
        width={150}
        height={150}
        className="mx-0 z-10 md:ml-4 w-[100px] h-[100px] md:w-[150px] md:h-[150px]"
      />
      <p className="text-xl md:text-3xl font-title font-black text-white">{core.public.challenges.title}</p>
      <div className="flex md:flex-row flex-col gap-2 md:gap-10 justify-center items-center md:w-full md:max-w-6xl z-10">
        <Image
          src="/img/v2/home/users.webp"
          alt="Challenge"
          width={380}
          height={250}
          className="mx-auto shrink-0 w-[300px] h-[200px] md:w-[380px] md:h-[250px]"
        />

        <div className="flex flex-col gap-4 justify-center items-center md:items-start md:w-1/2 md:mx-7 px-4">
          <p className="text-base text-white/85 text-center md:text-left">
            {core.public.challenges.description}
            {' '}
            <span className=" font-bold text-hprimary-500">{core.public.challenges.span}</span>
            {' '}
            {core.public.challenges.description2}
            <br />
            {' '}
            <span className="font-bold text-white">{core.public.challenges.span2}</span>
          </p>
          <div className="w-full max-w-xs">
            <HButton
              label={core.public.challenges.textLink}
              mode="secondary"
              size="large"
              onPress={() => {
                router.push(core.public.challenges.link);
              }}
              fat
              disabled={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(ChallengesSection);
